/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemFinancialsResponseSchema = z.object({
  capexPercentage: z
    .string()
    .describe(
      "CapEx percentage stored directly on this item. MVP business rule: only a root item's own CapEx % is meaningful — a descendant's stored value (if any, e.g. from before this rule existed) is preserved here but must not be used for display or calculation; use effectiveCapexPercentage instead.",
    )
    .nullish(),
  computedAt: z.iso
    .datetime()
    .describe(
      'When these financial values were last computed or updated. For items with a computed aggregate, this is when the rollup was last calculated; for items with only direct financial values (budget, CapEx%, forecast revenue) and no computed aggregate yet, this is when that direct value was last set.',
    ),
  descendantsBudgetAmount: z
    .string()
    .describe("Sum of this item's descendants' effective budgets")
    .nullish(),
  effectiveBudget: z
    .string()
    .describe(
      "Effective budget: this item's own budget if set, otherwise the sum of its descendants' effective budgets",
    )
    .nullish(),
  effectiveCapexPercentage: z
    .string()
    .describe(
      "This item's CapEx % as it should be displayed: its own value if it is the root of its item hierarchy, otherwise its root ancestor's value. Null if the root has none set.",
    )
    .nullish(),
  effectiveForecastRevenue: z
    .string()
    .describe(
      "This item's forecast revenue as it should be displayed: its own value if it is the root of its item hierarchy, otherwise its root ancestor's value. Null if the root has none set.",
    )
    .nullish(),
  financialStatus: z
    .enum(['NOT_STARTED', 'ON_TRACK', 'OVER_PACE', 'UNDER_PACE', 'COMPLETE'])
    .describe(
      'Burn vs straight-line status: how rolled actual cost compares to the effective budget and the planned schedule as of today. Null when effective budget, rolled actual cost, or valid planned start/finish dates are unavailable.',
    )
    .nullish(),
  hierarchyRootSource: z
    .enum(['SELF', 'PARENT'])
    .describe(
      "Whether effectiveCapexPercentage/effectiveForecastRevenue came from this item itself (root) or was inherited from its root ancestor — the same value for both, since it reflects the item's own position in its hierarchy, not anything specific to either field.",
    ),
  itemId: z.int().describe('Item id'),
  opexPercentage: z
    .string()
    .describe("OpEx percentage of this item's own budget, derived from capexPercentage")
    .nullish(),
  rolledActualCost: z.string().describe('Actual cost for this item and its descendants').nullish(),
  rolledActualCostStatus: z
    .enum(['COMPLETE', 'INCOMPLETE', 'MISSING_TEAM', 'PRESERVED', 'UNAVAILABLE'])
    .describe(
      'Completeness of rolledActualCost, reflecting this item and all descendants. Same semantics as selfActualCostStatus.',
    )
    .nullish(),
  selfActualCost: z.string().describe('Actual cost for this item only').nullish(),
  selfActualCostStatus: z
    .enum(['COMPLETE', 'INCOMPLETE', 'MISSING_TEAM', 'PRESERVED', 'UNAVAILABLE'])
    .describe(
      'Completeness of selfActualCost: COMPLETE (trustworthy, including a valid zero), INCOMPLETE (computed but some inputs were missing), MISSING_TEAM (time was logged but no team is assigned, so cost is a valid-looking zero rather than a computed one), PRESERVED (a prior value, not freshly computed), or UNAVAILABLE (no value could be computed or preserved). Null for items predating this field.',
    )
    .nullish(),
  selfBudgetAmount: z.string().describe('Budget for this item only').nullish(),
  selfForecastRevenueAmount: z
    .string()
    .describe(
      "Forecast revenue stored directly on this item. MVP business rule: only a root item's own forecast revenue is meaningful — a descendant's stored value (if any, e.g. from before this rule existed) is preserved here but must not be used for display or calculation; use effectiveForecastRevenue instead.",
    )
    .nullish(),
});
